import { Shark, View } from "shark-mvc";

import templateContent from "./user-profile.html";

import activeWorkSessionDisplayComponent from "../../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import notificationManager from "../../managers/notificationManager";
import userManager from "../../managers/userManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import workSessionDetailsModalComponent from "../../components/workSessionDetailsModal/workSessionDetailsModalComponent";

class UserProfileView extends View {
	afterLoad () {
		document.addEventListener("mousedown", this.document_mousedownHandler);
	}

	constructor () {
		super("userProfileView");

		this.setTemplate(templateContent);
		this.$mainRoute = "user-profile";
	}


	addWorkingHours () {
		const { currUser } = Shark.get();

		if (currUser) {
			currUser.addWorkingHours();
			Shark.render(); // Non ascolto ancora i change nei model...
		}
	}

	addWorkingHoursBtn_clickHandler () {
		this.addWorkingHours();
	}
	
	beforeLoad () {
		this.updateMenuTitle();

		const { currUser } = Shark.get();
		currUser.on("preferences.themeChanged", this.updateTheme);
	}

	beforeUnload () {
		document.removeEventListener("mousedown", this.document_mousedownHandler);

		const { currUser } = Shark.get();
		currUser.off("preferences.themeChanged", this.updateTheme);
	}

	deleteUserPicture () {
		const { currUser } = Shark.get();

		currUser.pictureURL = "";
		this.saveCurrentUserPicture();
	}

	deleteUserPicture_clickHandler () {
		if (confirm("Vuoi davvero eliminare la foto profilo?")) {
			this.deleteUserPicture();
		}
	}

	deleteWorkingHours (index) {
		// console.log("deleteWorkingHours", index);
		const { currUser } = Shark.get();

		if (currUser && confirm("Vuoi davvero cancellare questa fascia oraria?")) {
			currUser.deleteWorkingHours(index);
		}
	}

	deleteWorkingHoursBtn_clickHandler (event, data) {
		this.deleteWorkingHours(data.index);
	}

	document_mousedownHandler (event) {
		if (!event.target.closest(".dropdownMenuContainer")) {
			document.querySelector(".dropdownMenuContainer").classList.remove("show");
		}
	}

	init () {
		this.addComponents([activeWorkSessionDisplayComponent, mainNavComponent, waitBoxComponent, workSessionDetailsModalComponent]);

		// Alice: spostato 
		// const notificationTypeMap = [
		// 	{
		// 		icon: "icon-close",
		// 		type: "none",
		// 		label: Shark.$store.labels.notification_none,
		// 	},
		// 	{
		// 		icon: "icon-sound",
		// 		type: "beep",
		// 		label: Shark.$store.labels.notification_bip,
		// 	},
		// 	{
		// 		icon: "icon-music",
		// 		type: "sound",
		// 		label: Shark.$store.labels.notification_sound,
		// 	},
		// 	{
		// 		icon: "icon-voice",
		// 		type: "voice",
		// 		label: Shark.$store.labels.notification_voice,
		// 	},
		// ];

		Shark.set({
			availableVoices: Shark.$store.availableVoices || [],
			customProfilePicMenuOffsetX: 0,
			customProfilePicMenuOffsetY: 0,
			// notificationTypeMap,
			_saveProfileBtnStatusCSSClasses: "btn-primary",
			__isEditingProfile: false,
		});
	}

	// currUser_changeHandler () {
	// 	console.log("dlkwjsf");
	// }

	async userPictureField_changeHandler (event) {
		const uploadedFile = await userManager.uploadProfilePicture(event.target);

		if (uploadedFile.data.length > 0) {
			// console.log(uploadedFile.data);
			const { currUser } = Shark.get();

			currUser.pictureURL = uploadedFile.data[0].filePath;
			this.saveCurrentUserPicture();
		}
	}

	profileImageEdit_clickHandler (event) {
		var dropDownMenu = document.querySelector(".dropdownMenuContainer");
		// dropDownMenu.setAttribute("style", `lefdsfdgdfgft: ${event.originalEvent.offsetX}px; top: ${event.originalEvent.offsetY}px;`);
		dropDownMenu.classList.add("show");
		
		Shark.set({
			customProfilePicMenuOffsetX: event.originalEvent.offsetX,
			customProfilePicMenuOffsetY: event.originalEvent.offsetY,
		});
		
		// Shark.render();
	}

	saveCurrentUser () {
		const { currUser, runningWorkSession } = Shark.get();
	
		if (currUser) {
			waitBoxComponent.open();

			userManager.save(currUser)
			.then(() => {
				if (!runningWorkSession || runningWorkSession.guid === "") {
					notificationManager.stopNotWorkingTimeNotifications();
					notificationManager.startShouldBeWorkingNotifications();
				}
				waitBoxComponent.close();
			});
		}
	}

	async saveCurrentUserPicture () {
		const { currUser } = Shark.get();
	
		if (currUser) {
			waitBoxComponent.open();
			await userManager.saveUserPicture(currUser);
			waitBoxComponent.close();	
		}
	}

	saveProfileBtn_clickHandler () {
		this.saveCurrentUser();
		
		Shark.set({
			__isEditingProfile: false,
		});
	}

	editUserPicture_clickHandler () {
		document.getElementById("userPictureField").click();
	}

	toggleProfileEditing () {
		// const { currUser } = Shark.get();

		Shark.$store.__isEditingProfile = !Shark.$store.__isEditingProfile;
		// currUser.updateScreenWithModelValues();
	}

	toggleProfileEditingBtn_clickHandler () {
		const { currUser } = Shark.get();

		if (Shark.$store.__isEditingProfile && currUser.isDirty()) {
			if (!confirm(Shark.$store.labels.warning_changes_not_saved)) {
				return;
			}

			if (currUser.guid === "") {
				// this.close();
			}
			else {
				// currUser.restore();
			}
		}

		if (currUser.guid === "") {
			// this.close();
		}
		else {
			this.toggleProfileEditing();
		}
	}

	updateTheme(event, data) {
		document.body.classList.remove(data.oldValue);
		document.body.classList.add(data.newValue);
	}

	updateMenuTitle() {
		Shark.set({
			__menuTitle: Shark.$store.labels.user_profile,
		});
	}
}

const userProfileView = new UserProfileView();

Shark.registerView(userProfileView);

export default userProfileView;
